// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/breadcrumbs/breadcrumbs.js#1 $
'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcBreadcrumbs
* @element ANY
* @description
* # tcBreadcrumbs
* Displays page Breadcrumbs
*/
angular.module('tcApp')
.directive('tcBreadcrumbs', function($mdSidenav, BreadcrumbService, GlobalService, $mdPanel, $location,
										$mdMedia, $window, tcConstants) {
	return {
		templateUrl: 'template/breadcrumbs/breadcrumbs.html',
		restrict: 'E',
		scope: {},
		link: function(scope) {
			scope.BreadcrumbService = BreadcrumbService;
			scope.viewModel = {
				toggles: {
					breadcrumbs: false
				}
			};
			scope.globalStrings = GlobalService.getGlobalStrings();
			
			var breadcrumbPanelCtrl = function(mdPanelRef, $scope, data, viewModel, globalStrings) {
				$scope.data = data;
				$scope.viewModel = viewModel;
				$scope.globalStrings = globalStrings;
				$scope.viewModel.htmlIdPrefix = 'tc_BreadcrumbPanel-breadcrumb-';
				
				$scope.navBreadcrumb = function(index) {
					$scope.closePanel();
					$scope.viewModel.toggles['breadcrumbs'] = false;
					// call function on main breadcrumb scope
					scope.navBreadcrumb(index);
				};
				
				$scope.closePanel = function() {
					$scope.viewModel.toggles['breadcrumbs'] = false;
					mdPanelRef && mdPanelRef.close();	
				};
				
				$scope.handleKeydown = function($event) {
					if (($event.keyCode === tcConstants.KEY_CODE.DOWN_ARROW) || ($event.keyCode === tcConstants.KEY_CODE.UP_ARROW)) {
						$event.preventDefault();
						var currentElementId = $event.target.id;
						var idPrefix = $scope.viewModel.htmlIdPrefix;
						if (currentElementId.indexOf(idPrefix) !== -1) {
							var index = parseInt(currentElementId.split(idPrefix)[1]);
							var nextElementId = '';
							if ($event.keyCode === tcConstants.KEY_CODE.DOWN_ARROW) {
								if (index >= $scope.data.breadcrumbs.length) {
									// at last focusable breadcrumb, wrap to top
									nextElementId = idPrefix + '0';
								} else {
									nextElementId = idPrefix + (index + 1);	
								}
							} else { // up arrow
								if (index == 0) {
									// at top, wrap to last focusable breadcrumb
									nextElementId = idPrefix + ($scope.data.breadcrumbs.length);
								} else {
									nextElementId = idPrefix + (index - 1);	
								}	
							}
							if (nextElementId !== '') {
								var nextElement = $window.document.getElementById(nextElementId);
								if (nextElement) nextElement.focus();
							}
						}
					}
				};
			};
			
			scope.openBreadCrumbPanel = function($event) {
				var panelPosition = $mdPanel.newPanelPosition().relativeTo('#tc_breadcrumb-wrapper')
				.addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);
				var panelConfig = {
					controller: breadcrumbPanelCtrl,
					controllerAs: 'ctrl',
					bindToController: false,
					position: panelPosition,
					targetEvent: $event,
					templateUrl: 'template/breadcrumbs/breadcrumbPanel.html',
					clickOutsideToClose: true,
					escapeToClose: true,
					focusOnOpen: true,
					trapFocus: true,
					locals: {
						data: BreadcrumbService.data,
						viewModel: scope.viewModel,
						globalStrings: scope.globalStrings
					},
					onRemoving: function() {
						scope.viewModel.toggles['breadcrumbs'] = false;
						GlobalService.onModalToggle(false);
					},
					origin: '#tc_Breadcrumbs-toggle'
				};
				
				$mdPanel.open(panelConfig);
				GlobalService.onModalToggle(true);
				$event.stopPropagation();
			};
			
			scope.getBackToCaption = function() {
				var data = BreadcrumbService.data.breadcrumbs;
				var length = BreadcrumbService.data.breadcrumbs.length;
				var backTo = scope.globalStrings['BackTo']; 
				if ($mdMedia('xs')) {
					return scope.globalStrings['Back'];
				} else {
					return backTo + ' ' + data[length - 2].caption;			
				}
			};
			
			scope.togglePanel = function($event) {
				scope.viewModel.toggles['breadcrumbs'] = !scope.viewModel.toggles['breadcrumbs'];
				if (scope.viewModel.toggles['breadcrumbs']) {
					scope.openBreadCrumbPanel($event);
				}
				$event.stopPropagation();		
			};
			
			scope.getLink = function(index) {
				if (index >= 0) {
					return BreadcrumbService.data.breadcrumbs[index].linkUrl;
				}
			};
			
			scope.navBreadcrumb = function(index) {
				if (BreadcrumbService.data.breadcrumbs[index + 1].embeddedIndex) {
					var length = BreadcrumbService.data.breadcrumbs.length;
					var steps = (length - 1) - index; // steps between current and selected breadcrumbs
					// Remove necessary embedded breadcrumbs from list 
					BreadcrumbService.data.breadcrumbs = 
						BreadcrumbService.data.breadcrumbs.splice(0,(BreadcrumbService.data.breadcrumbs.length - steps));
					BreadcrumbService.storeBreadcrumbData();
				} else if (angular.isDefined(index)) {
					$location.url(scope.getLink(index));
				}	
			};
			
			scope.navBack = function() {
				var breadcrumbsLength = BreadcrumbService.data.breadcrumbs.length;
				if (breadcrumbsLength > 1) scope.navBreadcrumb(breadcrumbsLength - 2);
			};
		}
	};
})

.service('BreadcrumbService', function($window, $rootScope, $location, $document, $interval, $injector,
										$timeout, $log, $mdUtil, ComponentCache, ElementStateService, RouteParamsCache) {
	var serviceInstance = this;
	var embeddedBreadcrumbInterval = undefined;
	
	this.initialiseData = function(menuCaption) {
		this.data = {
			breadcrumbs: [],
			menuCaption: menuCaption
		};
	};

	// Persistance
	var breadcrumbSessionKey = 'tc.breadcrumbs';
	
	this.storeBreadcrumbData = function() {
		try {
			$window.sessionStorage.setItem(breadcrumbSessionKey, angular.toJson(this.data));
		} catch (err) {
			$log.log('Breadcrumb storage issue: ' + err);
		}
	};
	
	this.clearBreadcrumbData = function() {
		try {
			$window.sessionStorage.removeItem(breadcrumbSessionKey);
			this.initialiseData();
		} catch (err) {
			$log.log('Breadcrumb storage issue: ' + err);
		}
	};
	
	this.loadBreadcrumbData = function() {
		try {
			var sessionBreadcrumbs = angular.fromJson($window.sessionStorage.getItem(breadcrumbSessionKey));
			if (sessionBreadcrumbs) {
				this.data.breadcrumbs = sessionBreadcrumbs.breadcrumbs;
				this.data.menuCaption = sessionBreadcrumbs.menuCaption;
			}
		} catch (err) {
			$log.log('Breadcrumb storage issue: ' + err);
		}
	};
	
	// Use new sessionKey for embedded instance and clear any data loaded using parent sessionkey
	this.initialiseEmbeddedInstance = function() {
		try {
			breadcrumbSessionKey = 'tcBreadcrumbs-embedded';
			this.initialiseData();
			this.watchParentBreadcrumbs();
		} catch (err) {
			$log.log('Breadcrumb storage issue: ' + err);	
		}
	};
	
	// Listeners
	this.onRouteChangeHandleBreadcrumbs = function(event, newRoute) {
		if (angular.isDefined(embeddedBreadcrumbInterval)) $interval.cancel(embeddedBreadcrumbInterval);
		var locationPath = $location.path();
		if ((locationPath === '/Component/SSUserLogon') || (locationPath === '/Logout')) return;
		
		serviceInstance.updateBreadcrumbs(newRoute);
		serviceInstance.storeBreadcrumbData();
	};
	
	this.menuSelectedListener = function(event, menuCaption) {
		serviceInstance.initialiseData(menuCaption);
		serviceInstance.storeBreadcrumbData();
	};
	
	// Called when opening Clinical Viewer
	this.watchEmbeddedBreadcrumbs = function() {
		// returns length of embedded instance breadcrumb list
		var getEmbeddedbreadcrumbsLength = function() {
			var embeddedBreadcrumbs = angular.fromJson($window.sessionStorage.getItem('tcBreadcrumbs-embedded'));
			if ((angular.isObject(embeddedBreadcrumbs)) && (embeddedBreadcrumbs['breadcrumbs'])) {
				return embeddedBreadcrumbs['breadcrumbs'].length;
			} else {
				return 0;	
			}
		};
		var previousEmbeddedLength = getEmbeddedbreadcrumbsLength();
		
		// Repeatedly check for changes to embedded breadcrumbs
		embeddedBreadcrumbInterval = $interval(function() {
			var currentEmbeddedLength = getEmbeddedbreadcrumbsLength();
			// If breadcrumb has been added in embedded instance, create proxy "embedded" breadcrumb to mimic in parent instance
			if ((currentEmbeddedLength === (previousEmbeddedLength + 1)) && (previousEmbeddedLength > 0)) {
				var embeddedObj = angular.fromJson($window.sessionStorage.getItem('tcBreadcrumbs-embedded'));
				if ((angular.isObject(embeddedObj)) && (embeddedObj['breadcrumbs'])) {
					var desc = embeddedObj['breadcrumbs'][currentEmbeddedLength - 1].caption;
					var prevSpacer = serviceInstance.data.breadcrumbs[serviceInstance.data.breadcrumbs.length - 1].spacer;
					var spacer = prevSpacer + '\u00A0\u00A0\u00A0';
					var newBreadcrumb = {
						caption: desc,
						linkUrl: '',
						spacer: spacer,
						embeddedIndex: currentEmbeddedLength - 1, // index of the breadcrumb within the embedded instance
					};
					serviceInstance.data.breadcrumbs.push(newBreadcrumb);
					serviceInstance.storeBreadcrumbData();	
				}
			// Breadcrumb has been removed from embedded instance
			} else if (currentEmbeddedLength < previousEmbeddedLength) {
				var length = serviceInstance.data.breadcrumbs.length;
				if (length > 0) {
					// If we still have proxy breadcrumb for embedded breadcrumb that was removed, remove it from the parent list
					// this should only happen if event within embedded instance removes breadcrumb (e.g. update)
					if ((serviceInstance.data.breadcrumbs[length - 1].embeddedIndex) 
						&& (currentEmbeddedLength < (serviceInstance.data.breadcrumbs[length - 1].embeddedIndex + 1))) {
						var steps = previousEmbeddedLength - currentEmbeddedLength;
						serviceInstance.data.breadcrumbs = 
							serviceInstance.data.breadcrumbs.splice(0,(serviceInstance.data.breadcrumbs.length - steps));
						serviceInstance.storeBreadcrumbData();
					}
				}	
			}
			previousEmbeddedLength = currentEmbeddedLength;		
		}, 250);
	};
	
	// Called only within embedded Clinical Viewer Instance
	this.watchParentBreadcrumbs = function() {
		// Returns embeddedIndex of last parent breadcrumb
		var getParentBreadcrumbsEmbeddedIndex = function() {
			var parentBreadcrumbs = angular.fromJson($window.sessionStorage.getItem('tc.breadcrumbs'));
			if ((angular.isObject(parentBreadcrumbs)) && (parentBreadcrumbs['breadcrumbs'])) {
				var length = parentBreadcrumbs['breadcrumbs'].length;
				return parentBreadcrumbs['breadcrumbs'][length - 1].embeddedIndex;
			}
		};

		var previousEmbeddedIndex = getParentBreadcrumbsEmbeddedIndex();
		
		// Repeatedly check for updates to parent breadcrumbs and navigate within embedded instance as necessary
		$interval(function() {
			var newEmbeddedIndex = getParentBreadcrumbsEmbeddedIndex();
			var embeddedLength = serviceInstance.data.breadcrumbs.length;
			if (embeddedLength > 1) {
				// If breadcrumb has been removed from parent breadcrumb list
				if ((newEmbeddedIndex < previousEmbeddedIndex)
					|| ((angular.isUndefined(newEmbeddedIndex)) && (angular.isDefined(previousEmbeddedIndex)))) {
					if (angular.isUndefined(newEmbeddedIndex)) {
						// current parent breadcrumb is not embedded so return to first in child instance
						$location.url(serviceInstance.data.breadcrumbs[0].linkUrl);	
					} else if (newEmbeddedIndex >= 0) {
						// navigate to embeddedIndex of last parent breadcrumb
						$location.url(serviceInstance.data.breadcrumbs[newEmbeddedIndex].linkUrl);
					}
				}
			}
			previousEmbeddedIndex = newEmbeddedIndex;	
		}, 250);
	};

	this.updateBreadcrumbs = function(newRoute) {
		// Get the caption, depending on component/chart
		var caption = '';
		if (angular.isDefined(newRoute.locals.componentData)) {
			if ((angular.isDefined(newRoute.params.componentName))
				&& (newRoute.params.componentName === 'SSUserLogon')) {
				// Never allow to breadcrumb back to the logon screen
				return;
			}
			if (angular.isDefined(newRoute.locals.componentData.data.componentHeaderCaption)) {
				if (newRoute.locals.componentData.data.componentHeaderCaption != '') {
					caption = newRoute.locals.componentData.data.componentHeaderCaption;
				} else {
					caption = newRoute.locals.componentData.data.componentName;
				}
			} else if (angular.isDefined(newRoute.params.componentName)) {
				caption = newRoute.params.componentName;
			}
		} else if (angular.isDefined(newRoute.locals.chartData) && 
			angular.isDefined(newRoute.locals.chartData.data.caption)) {
			caption = newRoute.locals.chartData.data.caption;
		} else if (angular.isDefined(newRoute.locals.acnData) && 
			angular.isDefined(newRoute.locals.acnData.data.caption)) {
			caption = newRoute.locals.acnData.data.caption;
		} else if (angular.isDefined(newRoute.locals.uprData) && 
			angular.isDefined(newRoute.locals.uprData.data.caption)) {
			caption = newRoute.locals.uprData.data.caption;
		} else if (angular.isDefined(newRoute.locals.floorplanData) && 
			angular.isDefined(newRoute.locals.floorplanData.data.caption)) {
			caption = newRoute.locals.floorplanData.data.caption;
		} else if (angular.isDefined(newRoute.locals.layoutData)) {
			caption = 'Layout Editor';
		} else if (angular.isDefined(newRoute.locals.pwbData) && 
			angular.isDefined(newRoute.locals.pwbData.data.caption)) {
			caption = newRoute.locals.pwbData.data.caption;
		} else if (angular.isDefined(newRoute.locals.orderentryData) 
			&& angular.isDefined(newRoute.locals.orderentryData.data.caption)) {
			caption = newRoute.locals.orderentryData.data.caption;
		}  else if (angular.isDefined(newRoute.locals.clinicalViewerData)) {
			$window.sessionStorage.removeItem('tcBreadcrumbs-embedded');
			this.watchEmbeddedBreadcrumbs();
			caption = newRoute.locals.clinicalViewerData.data.caption;
		}  else if (angular.isDefined(newRoute.locals.worklistData)) {
			caption = newRoute.locals.worklistData.data.caption;
		} else {
			caption = 'Unknown';
		}
		
		// Remove matching breadcrumb if going back in history
		for (var i = 0; i < this.data.breadcrumbs.length; i++) {
			if (this.data.breadcrumbs[i].linkUrl === $location.url()) {
				angular.forEach(this.data.breadcrumbs.splice(i + 1, this.data.breadcrumbs.length), function(breadcrumb) {
					ComponentCache.remove(angular.toJson(breadcrumb.routeParams));
					ElementStateService.remove(angular.toJson(breadcrumb.routeParams));
					RouteParamsCache.remove(breadcrumb.linkUrl);
				});
				return;
			}
		}
		
		// If we have any proxy embedded breadcrumbs, remove them before adding new 
		if ((this.data.breadcrumbs.length > 1) && (this.data.breadcrumbs[this.data.breadcrumbs.length - 1].embeddedIndex)) {
			var embeddedBreadcrumbs = 1;
			while (this.data.breadcrumbs[this.data.breadcrumbs.length - (embeddedBreadcrumbs + 1)].embeddedIndex) {
				embeddedBreadcrumbs++;	
			}
			this.data.breadcrumbs = this.data.breadcrumbs.splice(0,(this.data.breadcrumbs.length - embeddedBreadcrumbs));
		}
		
		var spacer = '';
		if (this.data.breadcrumbs.length > 0) {
			var prevSpacer = this.data.breadcrumbs[this.data.breadcrumbs.length - 1].spacer;
			if (newRoute.params.Dialog > this.data.breadcrumbs[this.data.breadcrumbs.length - 1].dialogLevel) {
				spacer = prevSpacer + '\u00A0\u00A0\u00A0';	
			} else {
				spacer = prevSpacer;
			}
		}
		// Create a new breadcrumb to add/replace
		var newBreadcrumb = {
			caption: caption,
			dialogLevel: (newRoute.params.Dialog ? newRoute.params.Dialog : 0),
			linkUrl: ($location.tkWillReplace ? undefined : $location.url()),
			routeParams: newRoute.params,
			spacer: spacer,
		};
		// Add or replace, depending on replace/redirect
		if ($location.tkReplaced && (this.data.breadcrumbs.length > 0)) {
			// If replacing url, don't add as the history length doesn't change. Just update link
			this.data.breadcrumbs[this.data.breadcrumbs.length - 1] = newBreadcrumb;
		} else {
			this.data.breadcrumbs.push(newBreadcrumb);	// Otherwise, add our new breadcrumb
		}
	};
	
	// Called from router.js after navigating /Reload or /Back
	this.navigateBack = function(steps) {
		if (angular.isNumber(steps)) {
			var breadcrumbsLength = this.data.breadcrumbs.length;
			if (breadcrumbsLength > steps) {
				var breadcrumb = this.data.breadcrumbs[(breadcrumbsLength - 1) - steps];
				if (angular.isObject(breadcrumb)) {
					var navUrl = breadcrumb.linkUrl;
					if (angular.isDefined(navUrl)) $location.url(navUrl);
				}
			}
		}
	};
	
	// Called from router.js /CloseReload route
	this.closeReload = function() {
		var steps = 2; // default steps
		var currentBreadcrumbIndex = this.data.breadcrumbs.length - 2;
		
		// Breadcrumbs cannot depend on GlobalService directly as will generate circular dependency
		// That is why in this specific case need to use $injector
		// If HSCV embedded cross-domain cannot access $window.top.tkSystemUI
		// but as not TCUI embedded, logic with frames below need be skipped anyway
		var globalService = $injector.get('GlobalService'); //eslint-disable-line
		var isHSCV = globalService.isHealthShareViewer();
		
		// If we are embedded into TC UI and try to go back further than we can,
		// just go to home page instead		
		if ((!isHSCV) && (this.data.breadcrumbs[currentBreadcrumbIndex].dialogLevel == 0)) {
			if ($window.top.tkSystemUI == false) {
				$window.top.frames['eprmenu'].document.getElementById('MainMenuLinksHome').click();
				return;
			}
		}

		// Loop up the list starting with breadcrumb directly before current breadcrumb 
		for (var i = currentBreadcrumbIndex - 1; i > 0; i--) {
			// For each subsequent breadcrumb, as soon as Dialog level changes break, otherwise increment steps
			if (this.data.breadcrumbs[currentBreadcrumbIndex].dialogLevel != this.data.breadcrumbs[i].dialogLevel) {
				break;
			}
			steps++;
		}
		this.navigateBack(steps);	
	};
	
	/**
	 * @description
	 * Updates the current breadcrumb caption and page title.
	 * Called from websys_updateBreadcrumbCaption for embedded TCUI components,
	 * or websys_setComponentCaption when updating a component caption dynamically
	 * @param {string} caption The caption to set for the breadcrumb
	 */
	this.updateCurrentCaption = function updateCurrentCaption(caption) {
		if (!angular.isString(caption)) return;
		if (!this.data.breadcrumbs || (this.data.breadcrumbs.length < 1)) return;

		this.data.breadcrumbs[this.data.breadcrumbs.length - 1].caption = caption;
		// Use injector to access GlobalService, otherwise it causes a circular dependency
		var globalService = $injector.get('GlobalService'); //eslint-disable-line
		if (!globalService) return;

		// Set the page title to match the breadcrumb
		globalService.setPageTitle({
			componentHeaderCaption: caption,
		});
	};
	
	/// resets the breadcrumb to the last item (like a main menu caption)
	///  used with isInSecurityOverride (Break The Glass)
	this.resetToLastBreadcrumb = function() {
		var lastCaption = '';
		var foundIndex = -1;
		if ((this.data.breadcrumbs) && (this.data.breadcrumbs.length > 0)) {
			var currentLocation = $location.url();
			var lastBreadcrumbIndex = this.data.breadcrumbs.length - 1;
			// need to traverse the items as sometimes the breadcrumb is already updated with
			//  the current page by the time this function is called
			//  eg patient find vs epr chart
			for (var i = lastBreadcrumbIndex; i >= 0; i--) {
				if (this.data.breadcrumbs[i].linkUrl !== currentLocation) {
					lastCaption = this.data.breadcrumbs[i].caption;
					foundIndex = i;
					break;
				}
			}
		}
		if (foundIndex !== -1) {
			// where the breadcrumb was already updated with the current page,
			//  use the last item caption as the menu caption and remove all previous items to the current page
			if (foundIndex !== lastBreadcrumbIndex) {
				this.data.breadcrumbs.slice(foundIndex + 1);
				this.data.menuCaption = lastCaption;
			} else {
				this.initialiseData(lastCaption);
			}
			this.storeBreadcrumbData();
		} else {
			this.clearBreadcrumbData();
		}
	};
	
	// initialise and load breadcrumbs
	this.initialiseData();
	this.loadBreadcrumbData();
	
	$rootScope.$on('$routeChangeSuccess', this.onRouteChangeHandleBreadcrumbs, this); //eslint-disable-line
	$rootScope.$on('tcMenu:MainMenuSelected', this.menuSelectedListener, this); //eslint-disable-line
});
